// General enums for order entry

export enum EquityOrderAction {
  BUY = 'BUY',
  SELL = 'SELL',
  BUY_TO_COVER = 'BUY_TO_COVER',
  SHORT_SELL = 'SHORT_SELL'
}

export enum OptionOrderAction {
  BUY_TO_OPEN = 'BUY_TO_OPEN',
  BUY_TO_CLOSE = 'BUY_TO_CLOSE',
  BUY_TO_COVER  = 'BUY_TO_COVER',
  SELL_TO_CLOSE = 'SELL_TO_CLOSE',
  SELL_TO_OPEN_COVERED = 'SELL_TO_OPEN_COVERED',
  SELL_TO_OPEN_UNCOVERED = 'SELL_TO_OPEN_UNCOVERED',
  SHORT_SELL = 'SHORT_SELL'
}

export enum MutualFundOrderAction {
  BUY = 'BUY',
  SELL = 'SELL',
  SELL_ALL_MF = 'SELL_ALL_MF',
  SWITCH = 'SWITCH',
  PARTIAL_MF_SWITCH = 'PARTIAL_MF_SWITCH',
  FULL_MF_SWITCH = 'FULL_MF_SWITCH'
}

export enum MutualFundDividendType {
  CASH = 'CASH',
  REINVEST = 'REINVEST',
  NA = 'NA'
}

export enum MutualFundQuantityType {
  DOLLAR_AMOUNT= 'DOLLAR_AMOUNT',
  UNITS = 'UNITS',
  FULL_BALANCE = 'FULL_BALANCE'
}

export enum OptionType {
  CALL = 'CALL',
  PUT = 'PUT',
  UNKNOWN = 'UNKNOWN'
}

export enum OptionPriceType {
  BID = 'BID',
  ASK = 'ASK'
}

export enum QuoteType {
  DELAYED = 'DELAYED',
  REAL_TIME = 'REAL_TIME'
}

export enum PricePlan {
  EVEN = 'EVEN',
  MARKET = 'MARKET',
  NET_CREDIT = 'NET_CREDIT',
  NET_DEBIT = 'NET_DEBIT',
  UNKNOWN = 'UNKNOWN'
}

// TODO : double check, this looks like a duplicate with above enum (PricePlan)
export enum PrincipalPriceType {
  EVEN = 'EVEN',
  NET_CREDIT = 'NET_CREDIT',
  NET_DEBIT = 'NET_DEBIT'
}

export enum Strategy {
  FTO = 'FTO', // First Triggers OCO
  MLO = 'MLO', // Multi Leg Order
  OCO = 'OCO', // One Cancels Other
  OTA = 'OTA', // One Triggers Another
  SPL = 'SPL', // Simple
  UNKNOWN = 'UNKNOWN'
}

export enum InsiderType {
  INSIDER = 'INSIDER',
  NONE = 'NONE',
  SIGNIFICANT_SHAREHOLDER = 'SIGNIFICANT_SHAREHOLDER'
}

export enum LifeCycleType {
  CURRENT = 'CURRENT',
  FUTURE = 'FUTURE',
  HISTORICAL = 'HISTORICAL',
  UNKNOWN = 'UNKNOWN'
}

/**
 * Currently this is created based on combining Active and Historical.
 * Should find a way to separate this into 2 different enums based on LifeCycleType
 */
export enum GroupOrderStatusType {
  CANCELLED = 'CANCELLED',
  EXPIRED = 'EXPIRED',
  FILLED = 'FILLED',
  OPEN = 'OPEN',
  UNDEFINED = 'UNDEFINED'
}

export enum OrderStatusType {
  ACKNOWLEDGED = 'ACKNOWLEDGED',
  ACTIVE = 'ACTIVE',
  CANCELLED = 'CANCELLED',
  CONFIRMED = 'CONFIRMED',
  CONFIRMED_TRANSMISSION = 'CONFIRMED_TRANSMISSION',
  CONTRACTED = 'CONTRACTED',
  DUMMY = 'DUMMY',
  ERROR = 'ERROR',
  EXPIRED = 'EXPIRED',
  FILLED = 'FILLED',
  MANUAL = 'MANUAL',
  OPEN = 'OPEN',
  OPEN_PENDING_TRIGGER = 'OPEN_PENDING_TRIGGER',
  OPEN_TRIGGERED = 'OPEN_TRIGGERED',
  PARTIALLY_FILLED = 'PARTIALLY_FILLED',
  PENDING = 'PENDING',
  PENDING_CANCEL = 'PENDING_CANCEL',
  RECEIVED = 'RECEIVED',
  REJECTED = 'REJECTED',
  TRANSMITTED = 'TRANSMITTED',
  UNDER_REVIEW = 'UNDER_REVIEW',
  UNKNOWN = 'UNKNOWN',
  UPDATE = 'UPDATE',
  ISM_PROBLEM = 'ISM_PROBLEM',
  KILLED = 'KILLED',
  // TODO: confirm if applicable
  SENT = 'SENT',
  UNSENT = 'UNSENT',
  PLACED = 'PLACED',
  WAITING = 'WAITING',
  LOCKED = 'LOCKED',
  HISTORY = 'HISTORY',
  INACTIVE = 'INACTIVE',
  ALL_INACTIVE = 'ALL_INACTIVE'
}

export enum PriceType {
  MARKET = 'MARKET',
  LIMIT = 'LIMIT',
  STOP_MARKET = 'STOP_MARKET',
  STOP_LIMIT = 'STOP_LIMIT',
  TRAILING_STOP_MARKET = 'TRAILING_STOP_MARKET',
  TRAILING_STOP_LIMIT = 'TRAILING_STOP_LIMIT'
  //  UNKNOWN = 'UNKNOWN' // TODO: verify if it is a valid value. used by order details in order status
}

export enum OrderActionParam {
  BO = 'BO' ,
  BC = 'BC',
  SOC = 'SOC',
  SOU = 'SOU',
  SC = 'SC',
  buy = 'buy',
  sell = 'sell'
}

export enum OrderDateType {
  DAY = 'DAY',
  CANCEL = 'CANCEL',
  DATE = 'DATE',
  EXTENDED_MARKET = 'EXTENDED_MARKET'
}
